import React from 'react'
const ThingsContext = React.createContext({
    explorePosts: [],
    posts: [],
    setExplorePosts: () => {},
    setPosts: () => {}
})
export default ThingsContext